import { render, staticRenderFns } from "./QuizQuestionRenderer.vue?vue&type=template&id=24847fe6&scoped=true"
import script from "./QuizQuestionRenderer.vue?vue&type=script&lang=js"
export * from "./QuizQuestionRenderer.vue?vue&type=script&lang=js"
import style0 from "./QuizQuestionRenderer.vue?vue&type=style&index=0&id=24847fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24847fe6",
  null
  
)

export default component.exports